export function toSnakeCase(value: string): string {
  return value.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function formatHour(hour: string | null | undefined): string | null {
  return hour ? `${hour}:00` : null;
}

export function formatHourRemoveSeconds(
  hour: string | null | undefined
): string | null {
  return hour ? hour.substring(0, hour.lastIndexOf(":")) : null;
}
